import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Set extends Component {

  state = {
    set: [],
    load: false,
  }

  componentDidUpdate(props) {
    if (props.data != this.props.data) {
      this.setCategory();
      this.selected();
    }
  }

  setCategory() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'set') {
        model.push({key: y.name, text: y.name, value: y.name});
      }
    });
    context.setState({
      setOption: model,
    });
  }

  selected() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'selectedset') {
        model.push(y.name);
      }
    });
    context.setState({
      set: model,
    });
  }

  add(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Adding Sets!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addspareset.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  remove(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Removing set!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/removespareset.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  Set = (f, { value }) => {
    this.check(value);
    this.setState({ set: value })
  }

  check(value) {
    let oldValue = this.state.set;
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      for (var i = 0; i < oldValue.length; i++) {
        if (length == 0) {
          this.remove(oldValue[i]);
          return;
        }
        for (var j = 0; j < length; j++) {
          if (oldValue[i] != value[j]) {
            this.remove(oldValue[i]);
            return;
          }
        }
      }
    }
  }

  render() {
    let { set } = this.state;
    let { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
        <Dropdown placeholder='Set' style={{ borderColor: '#5A9CBB' }}
         multiple fluid search selection onChange={this.Set}
         options={this.state.setOption} value={set} />
         {loading}
      </div>
    );
  }
}

export default Set;
